class reportTemplateAdd {
    constructor($scope, httpRequest, logger, formvalidateApi, $state, $timeout) {
        const parentFunctionId = -1 // 路径根目录id
        $scope.template = {
            files: [],
            mainReport: '', // 主模板的名字
            mainTemplate: 0, // 柱模板的下标
            orgIdList: [],
            parentFunctionId: '', // 路径id
            fileNameList: [], // 上传的模板文件名数组
            fileNewList: [], // 新上传的模板文件名数组
        }
        $scope.userAllOrgList = [] // 机构数组
        $scope.pathList = [] // 路径数组
        $scope.fileList = [] // 添加的文件数组
        $scope.$watch('template.mainTemplate', (newVal) => {
            const file = $scope.fileList.filter((file, index) => index === newVal)[0]
            file && ($scope.template.mainReport = file.name)
        })
        // 验证规则
        const required = { // 验证为必填项
            condition(value) {
                return !value || /^[ ]+$/.test(value)
            },
        }
        $scope.validateRules = {
            reportName: [{
                erromsg: '请填写报表名称',
                ...required,
            }, {
                erromsg: '最多输入6个汉字',
                condition(value) {
                    return value.length > 6
                },
            }],
            org: [{
                erromsg: '请指定正确的使用对象',
                condition(value) {
                    return !value.length
                },
            }],
            path: [{
                erromsg: '请指定正确的发布路径',
                condition(value) {
                    return !value
                },
            }],
            file: [{
                erromsg: '请上传模板文件',
                condition(value) {
                    return !value.length
                },
            }],
        }
        // 上传文件执行的方法
        $('#uploadFile').on('change', (e) => {
            const file = e.target.files[0]
            let isSame = false
            $timeout(() => {
                if ($scope.fileList.length) {
                    $scope.fileList.forEach((f, index, arr) => {
                        if (f.name === file.name) {
                            logger.logError('上传模板文件名不能相同')
                            isSame = true
                        }
                        if (!isSame && index === arr.length - 1) $scope.fileList.push(file)
                    })
                } else $scope.fileList.push(file)
                $scope.template.mainReport || ($scope.template.mainReport = $scope.fileList[0].name)
            })
        })
        // 删除文件执行的方法
        $scope.deleteFile = (index) => {
            $scope.fileList.splice(index, 1)
            $scope.template.mainTemplate === index && ($scope.template.mainTemplate = 0)
            logger.logSuccess('删除文件成功!')
        }
        // 点击暂存执行的方法
        $scope.save = async (opType) => {
            const validateResult = formvalidateApi.run()
            if (!validateResult) return
            try {
                const formData = new FormData()
                const mainTemplate = $scope.fileList[$scope.template.mainTemplate]
                $scope.template.files = $scope.fileList
                $scope.template.opType = opType
                $scope.template.fileNameList = $scope.template.files.map((file) => {
                    const format = file.name.substring(file.name.lastIndexOf('.'))
                    if (format !== '.frm' && format !== '.cpt') throw new Error('上传模板文件的格式不正确!')
                    return file.name
                })
                $scope.template.fileNewList = $scope.template.files.map((file) => file.name)
                if (mainTemplate) $scope.template.mainReport = mainTemplate.name
                else throw new Error('请选择主模板文件')
                Object.keys($scope.template).forEach((key) => {
                    if ($scope.template[key] instanceof Array) {
                        for (let i = 0; i < $scope.template[key].length; i++) {
                            formData.append(key, $scope.template[key][i])
                        }
                    } else formData.append(key, $scope.template[key])
                })
                const result = await httpRequest.post_importTemplate(formData)
                console.log(result)
                if (result.data.success) {
                    opType === 'save' ? logger.logSuccess('暂存模板文件成功!') : logger.logSuccess('发布模板文件成功!')
                    $state.go('system.settingcenter.reportTemplateSetting.list')
                }
            } catch (e) {
                logger.logError(e.message || e)
            }
        }
        // 点击取消执行的方法
        $scope.cancel = () => {
            $state.go('system.settingcenter.reportTemplateSetting.list')
        }
        // 获取使用对象和路径
        Promise.all([
            httpRequest.post_getSysOrganizationList({
                pageNum: 1,
                pageSize: 1000,
                param: { orgStatus: 1 },
            }),
            httpRequest.post_queryChildFunction(parentFunctionId),
        ]).then((res) => {
            $timeout(() => {
                $scope.userAllOrgList = res[0].data.value.list
                $scope.pathList = res[1].data.value
                $scope.pathList.forEach((path) => {
                    path.parentFunctionId === parentFunctionId && (path.cbDisable = true)
                })
            })
            console.log($scope.pathList)
        }).catch((err) => console.log(err))
        // 选择使用对象时执行的方法
        $scope.orgSelectChange = function (orgArr) {
            $scope.template.orgIdList = []
            orgArr.forEach((org) => $scope.template.orgIdList.push(org.orgId))
            // console.log($scope.template.orgIdList)
            // const inputDom = $('.org-box .form-control')
            // if ($scope.template.orgIdList.length) {
            //     inputDom.addClass('correct')
            //     inputDom.parents('.formfield-control').children('erro_msg_wrap').remove()
            // } else {
            //     inputDom.removeClass('correct')
            // }
            // console.log('org change', $('.org-box .form-control'))
        }
        // 选择路径执行的方法
        $scope.pathSelectChange = function (pathArr) {
            $scope.template.parentFunctionId = ''
            pathArr.length && ($scope.template.parentFunctionId = pathArr[0].functionId)
            console.log($scope.template.parentFunctionId)
            // const inputDom = $('.path-box .form-control')
            // if ($scope.template.parentFunctionId) {
            //     inputDom.addClass('correct')
            //     inputDom.parents('.formfield-control').children('erro_msg_wrap').remove()
            // } else {
            //     inputDom.removeClass('correct')
            // }
            // console.log('path change', $('.path-box .form-control'))
        }
        $scope.queryConfig = {
            queryName: 'orgName',
            queryKey: 'orgId',
            queryType: 'tree',
            parentIdName: 'parentOrgId',
            multiple: true,
            parentId: -1,
        }
        $scope.queryFunctionConfig = {
            queryName: 'functionName',
            queryKey: 'functionId',
            queryType: 'tree',
            parentIdName: 'parentFunctionId',
            multiple: false,
            parentId: parentFunctionId,
        }
    }
}

reportTemplateAdd.$inject = ['$scope', 'httpRequest', 'logger', 'formvalidateApi', '$state', '$timeout']

export default reportTemplateAdd



// WEBPACK FOOTER //
// ./src/app/system/settingcenter/reportTemplateSetting/reportTemplateAddCtrl.js